import endOfMonth from 'date-fns/endOfMonth'
import startOfMonth from 'date-fns/startOfMonth'
import { Analytics } from '@payu/paymentsos-types'

const OTHER = 'other'

const emptyGraphPoints = {
  keys: {},
  graphData: [
    { time: startOfMonth(new Date()).getTime() },
    { time: endOfMonth(new Date()).getTime() }
  ]
}

export default function convertRawDataToGraphData (
  data: Analytics.AnalyticsResponse,
  metric: Analytics.Metric['name'],
  dimension: Analytics.Dimension
): GraphData {
  return dataIsEmpty(data) ? emptyGraphPoints : mapDataToGraphPoints(data, metric, dimension)
}

function dataIsEmpty (data: Analytics.AnalyticsResponse): boolean {
  return !(data?.buckets?.length > 0)
}

interface GraphPoint {
  time: number;
  other?: number;
  [key: string]: number;
}

export interface GraphData {
  keys: {
    other?: number;
    [key: string]: number;
  };
  graphData: GraphPoint[]
}

function mapDataToGraphPoints (data: Analytics.AnalyticsResponse, metric: Analytics.Metric['name'], dimension: Analytics.Dimension): GraphData {
  const zeroKeys = data.buckets
    .filter(obj => obj.data.length > 0)
    .reduce((acc, item) => {
      item.data.forEach(({ dimensions }) => {
        const dimensionValue = dimensions?.[dimension]
        if (dimensionValue != null && !Object.prototype.hasOwnProperty.call(acc, dimensionValue)) {
          acc[dimensionValue as string] = 0
        } else if (dimensionValue === null && !Object.prototype.hasOwnProperty.call(acc, OTHER)) {
          acc[OTHER] = 0
        }
      })
      return acc
    }, {})

  const chartArr = data.buckets.map((bucket): GraphPoint => {
    const dateObj = { ...zeroKeys }
    if (bucket.data.length > 0) {
      bucket.data.forEach((item) => {
        if (item.dimensions[dimension]) {
          dateObj[item.dimensions[dimension]] = item.metrics[metric]
        } else {
          dateObj[OTHER] = item.metrics[metric]
        }
      })
    }
    return { ...dateObj, time: new Date(bucket.time_range.from).getTime() }
  })
  return { keys: zeroKeys, graphData: chartArr }
}

export { emptyGraphPoints }
